import { InjectionToken } from '@angular/core';

export const WindowRef = new InjectionToken<Window>('WindowToken');

export function _window(): Window {
  return window;
}

// https://juristr.com/blog/2016/09/ng2-get-window-ref/
// function _window(): any {
//   // return the global native browser window object
//   return window;
// }

// @Injectable()
// export class WindowRef {
//   get nativeWindow(): any {
//     return _window();
//   }
// }
